import { OverLay, StyledAnimation } from './Styled'

export default function PageLoading() {
  return (
    <OverLay>
      <StyledAnimation />
    </OverLay>
  )
}
